fade_elements = document.querySelectorAll(".fade-in");

for (var i = 0; i < fade_elements.length; i++) {
    fadeInElements(i);
}

function fadeInElements(i) {
    setTimeout(function () {
        fade_elements[i].classList.add("faded-in");
    }, i * 1000);
}
